import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import {
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from "reactstrap";
import {
  getAuthToken,
  getTeacherAuthToken,
} from "../../../utils/auth";
import {
  getUrlParameter,
} from "../../../utils/actions";
import {
  BackgroundListGetAction,
  UserBackgroundListGetAction,
  BoardPageUpdateAction,
} from "../../../store/screen/actions";
import { screenState, setError } from "../../../store/screen/slice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

import Delete from "../../../assets/images/icons/whiteboard-menu-c-3.svg";
import lightDelete from "../../../assets/images/icons/console-control-3.svg";

const BASE_URL = `${process.env.REACT_APP_API_URL}/elements/image/`;

interface Props {
  id: string;
  showModal: boolean;
  toggleModal: () => void;
}

const Index = ({ id, showModal, toggleModal }: Props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { errorMsg, success, pageInfo, boardInfo, backgroundCategorys, backgrounds, userUploads } = useAppSelector(state => screenState(state));

  const [selectedId, setSelectedId] = useState("");
  const [customActiveTab, setcustomActiveTab] = useState("native");
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [categoryId, setCategoryId] = useState<any>("");

  const toggleCustom = (tab: any) => {
      if (customActiveTab !== tab) {
          setcustomActiveTab(tab);
      }
  };

  const categoryIdSet = (id: any) => {
      if (categoryId !== id) {
        setCategoryId(id);
        dispatch(BackgroundListGetAction({ category_id: id }));
      }
  };

  useEffect(() => {
    if (backgroundCategorys.length !== 0) {
      setCategoryId(backgroundCategorys[0].id);
    }
  }, [backgroundCategorys]);

  useEffect(() => {
    let category;
    if (backgroundCategorys.length !== 0) {
      category = backgroundCategorys[0].id;
      setCategoryId(backgroundCategorys[0].id);
    }
    if (categoryId) {
      category = categoryId;
    }
    dispatch(BackgroundListGetAction({ category_id: category }));
  }, []);

  useEffect(() => {
    if (customActiveTab === "native") {
      if (categoryId) {
        dispatch(BackgroundListGetAction({ category_id: categoryId }));
      }
    } else if (customActiveTab === "userUpload") {
      dispatch(UserBackgroundListGetAction());
    }
  }, [customActiveTab]);

  useEffect(() => {
    if (boardInfo) {
      setSelectedId(boardInfo.background_id);
    }
  }, [boardInfo, backgrounds]);

  const setBackground = (background_id: string) => {
    if (boardInfo) {
      dispatch(BoardPageUpdateAction({
        id: id,
        board_id: boardInfo.id,
        pageNum: pageInfo.pageNum,
        is_deleted: false,
        background_id: background_id,
        name: boardInfo.name || "",
        content: boardInfo.content || "",
        order_num: boardInfo.order_num
      }));
    }    
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const file = e.target.files ?  e.target.files[0] : null;
    fileUpload(file);
  };

  const fileUpload = (file: any) => {
    if (file) {
      let token = null;
      if (getAuthToken()) {
        token = getAuthToken();
      } else if (getTeacherAuthToken()) {
        token = getTeacherAuthToken();
      }
      const headers = new Headers();
      if (token) {
        headers.append("userToken", token);
      }
      const fileFormData = new FormData();
      fileFormData.append("file", file);
      fetch(`${process.env.REACT_APP_API_URL}/api/elements/uploadBackgrounds`, {
        method:"POST",
        headers: headers,
        body: fileFormData
      })
      .then(response => response.json())
      .then(data => {
        if (data.status != "SUCCESS") {
          throw data;
        } else {
          // 
          dispatch(UserBackgroundListGetAction());
        }
      })
      .catch(e => {
        console.log("error", e);
  
        dispatch(setError("背景圖上傳失敗"));
      });
    }
  };

  const deleteImage = (item: any) => {
    let token = null;
    if (getAuthToken()) {
      token = getAuthToken();
    } else if (getTeacherAuthToken()) {
      token = getTeacherAuthToken();
    }
    const headers = new Headers();
    if (token) {
      headers.append("userToken", token);
    }
    fetch(`${process.env.REACT_APP_API_URL}/api/elements/deleteBackgrounds/${item.id}`, {
      method:"DELETE",
      headers: headers
    })
    .then(response => response.json())
    .then(data => {
      if (data.status != "SUCCESS") {
        throw data;
      } else {
        // 
          dispatch(UserBackgroundListGetAction());
      }
    })
    .catch(e => {
      console.log("error", e);

      dispatch(setError("背景圖刪除失敗"));
    });
  };

  const deleteSwitch = () => {
    setShowDelete(!showDelete);
  };

  return (
    <Modal id="bgModal" className="h-100 w-100 items-center justify-center sm:p-14 m-auto" isOpen={showModal} toggle={toggleModal} modalClassName="zoomIn" zIndex={1000205} centered>
      <div>
        <ModalHeader className="modal-title mb-4" id="myBgModal">
          選擇背景圖
        </ModalHeader>
        <div className="background-nav">
          <div className="ts-tab w-100 mt-4 flex">
            <Nav tabs className="nav justify-content-end rounded card-header-tabs border-bottom-0 flex-wrap w-100">
              <NavItem className="w-50 text-center">
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({ active: customActiveTab === "native" , })}
                  onClick={()=> { toggleCustom("native"); }}
                >
                  基本
                </NavLink>
              </NavItem>
              <NavItem className="w-50 text-center">
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({ active: customActiveTab === "userUpload" , })}
                  onClick={()=> { toggleCustom("userUpload"); }}
                >
                  用戶上傳
                </NavLink>
              </NavItem>
            </Nav>
          </div>
        </div>
        {customActiveTab === "native"? (
          <div className="background-nav sub-back-nav">
            <div className="ts-tab w-100 flex">
              <Nav tabs className="nav justify-content-center rounded card-header-tabs border-bottom-0 flex-wrap w-100">
                {(backgroundCategorys || []).map((item: any, index: number) => (
                  <NavItem className="text-center" key={index}>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({ active: categoryId === item.id , })}
                      onClick={()=> { categoryIdSet(item.id); }}
                    >
                      {item.title}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
            </div>
          </div>
        ) : null}
        {customActiveTab==="userUpload"? (
          <div className="userUpload-box">
            <input
              className="sr-only"
              id={`background-upload`}
              name={`background-upload`}
              type="file"
              accept=".jpg, .jpeg, .png, .gif"
              onChange={handleFileChange}
              hidden
            />
            <Button 
              className="rounded-pill continueBtn"
              variant="contained"
              onClick={() => {
                document.getElementById("background-upload")?.click();
              }}
            >
              上傳圖片
            </Button>
            <div className="userBackground-swtich">
              <div className="image-delete-switch">
                <div className="form-check mt-3">
                  <Input className="form-check-input fs-15" type="checkbox" id={`user-delete-switch`} onChange={() => deleteSwitch()} checked={showDelete} />
                  <Label className="form-check-label fs-16" htmlFor={`user-delete-switch`}>
                    啟用刪除圖片
                  </Label>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        <ModalBody id="myBgModalBody" className={`text-center ${customActiveTab === "userUpload"? "userUpload" : ""}`}>
          <Row>
            <Col>
              <TabContent activeTab={customActiveTab} className="text-muted">
                <TabPane tabId="native">
                  <div className="flex w-full flex-row flex-wrap pt-3 gap-2">
                    {(backgrounds || []).map((item: any, index: any) => (
                      <Col
                        xs={12}
                        sm={4}
                        md={3}
                        lg={2} 
                        key={item.id}
                        id={item.id}
                        className={`relative shrink-0 overflow-hidden rounded ring-2 focus-visible:outline-none focus-visible:ring-4  focus-visible:ring-primary-500 ring-gray-300 imageList-item ${selectedId === item.id? "selected" : ""}`}
                        onClick={() => setBackground(item.id)}
                      >
                        <div className="cursor-pointer bg-transparent" style={{ zIndex: 15 }}></div>
                        <div
                          className="absolute top-0 inset-0 h-100 w-100 overflow-hidden"
                          style={{ backgroundImage: `url(${ BASE_URL + item.thumbnail })`, backgroundPosition: "50% 50%", backgroundRepeat: "no-repeat", backgroundSize: "cover", zIndex: 4 }}
                        >
                        </div>
                      </Col>
                    ))}
                  </div>
                </TabPane>
                <TabPane tabId="userUpload">
                  <div className="flex w-full flex-row flex-wrap pt-3 gap-2">
                    {(userUploads || []).map((item: any, index: any) => (
                      <Col
                        xs={12}
                        sm={4}
                        md={3}
                        lg={2} 
                        key={item.id}
                        id={item.id}
                        className={`relative shrink-0 overflow-hidden rounded ring-2 focus-visible:outline-none focus-visible:ring-4  focus-visible:ring-primary-500 ring-gray-300 imageList-item ${selectedId === item.id? "selected" : ""}`}
                      >
                        <div
                          className="cursor-pointer bg-transparent"
                          style={{ zIndex: 15 }}
                          onClick={() => setBackground(item.id)}
                        ></div>
                        <div
                          className="absolute top-0 inset-0 h-100 w-100 overflow-hidden"
                          style={{ backgroundImage: `url(${ BASE_URL + item.thumbnail })`, backgroundPosition: "50% 50%", backgroundRepeat: "no-repeat", backgroundSize: "cover", zIndex: 4 }}
                        >
                        </div>
                        {showDelete? (
                          <div
                            className="image-delete"
                            onPointerDown={() => deleteImage(item)}
                            style={{ "--src": `url(${Delete})`, "--hover": `url(${lightDelete})` }}
                          >
                          </div>
                        ) : null}
                      </Col>
                    ))}
                  </div>
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </ModalBody>
      </div>
    </Modal>
  );
};

export default Index;